import './GlowSubWidgets.css';
import React, { useState } from "react";

function RelaxBlock(props) {
    const [relaxType, setRelaxType] = useState(props.type)

    return (
        <div className="glowBlockSubWidget">
            {relaxType === "unspecified" &&
                <div>
                    <p className="glowHeaderText"> relax </p>
                    <div className="row center overflow transitionOptionsDiv">
                        <p className="glowBlockSelectOptions" onClick={() => setRelaxType("deepBreath")}> deep breaths </p>
                        <p className="glowBlockSelectOptions" onClick={() => setRelaxType("flows")}> more coming soon </p>
                    </div>
                </div>
            }
        </div>
    )
}

export default RelaxBlock;